import { Component, computed, EventEmitter, inject, Output } from '@angular/core';
import { ThemeService } from '../services/theme';
import { ResponsiveService } from '../services/responsive';
import { v3LayoutFlags } from '../services/v3-layout';
import { FeatureFlagStore } from '../stores/feature-flags.store';
import { NEXT_EARNINGS_DATE } from '../earnings-data';

// V3's main-page "next earnings date" mini-card, mobile only for now — sits below the bigger
// V3EarningsOverview card inside V3Overview. Desktop content lands later, as part of a bigger
// desktop "Earnings" card (V3Overview is documented in v3-scores-overview/CLAUDE.md; see also root
// CLAUDE.md's App Versions section).
@Component({
  selector: 'app-v3-earnings-calendar',
  imports: [],
  standalone: true,
  templateUrl: './v3-earnings-calendar.html',
  styleUrl: './v3-earnings-calendar.scss',
  // Hides the host itself (not just its content) when nothing renders, so it doesn't still count
  // as a flex item and eat a gap in V3Overview's flex layout.
  host: { '[class.hidden]': '!visible()' },
})
export class V3EarningsCalendar {
  private readonly themeService = inject(ThemeService);
  private readonly responsiveService = inject(ResponsiveService);
  private readonly featureFlagStore = inject(FeatureFlagStore);

  // finnetApp is mobile-only regardless of viewport width (e.g. iPad) — isFinnetDesktop excludes it.
  private readonly layout = v3LayoutFlags(this.themeService, this.responsiveService);

  readonly visible = computed(
    () => !this.layout.isDesktop() && this.featureFlagStore.isEarningsDateEnabled(),
  );

  readonly nextEarningsDate = NEXT_EARNINGS_DATE;

  @Output() navigate = new EventEmitter<void>();

  onNavigate() {
    this.navigate.emit();
  }
}
